import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  pRoot: {
    borderRadius: theme.spacing(0.5),
    overflow: "scroll"
  },

  pLevelContainer: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.25),
    color: theme.palette.text.main,
    background: theme.palette.jamii.yellow,
    border: `2px solid ${theme.palette.jamii.darkAccent}`,
    boxShadow: theme.customShadows(theme.palette.jamii.darkAccent)
  },
  pLevelText: {
    fontFamily: "Courier Prime",
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textTransform: "capitalize"
  },

  pEditContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    color: theme.palette.jamii.mildBlue,
    cursor: "pointer"
  },
  pEditText: {
    fontSize: theme.typography.body1.fontSize,
    marginRight: theme.spacing(0.5)
  }
}));
